function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropableContainer, DropdownList, DropdownListContainer, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { useKeypress } from '@keen.io/react-hooks';
import { Container, OperatorsList } from './FilterOperator.styles';
import { createOptions, getLabel } from './utils';

var FilterOperator = function FilterOperator(_ref) {
  var operator = _ref.operator,
      property = _ref.property,
      propertyType = _ref.propertyType,
      onChange = _ref.onChange;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      editMode = _useState2[0],
      setEditMode = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectionIndex = _useState4[0],
      setIndex = _useState4[1];

  var operators = useMemo(function () {
    return createOptions(propertyType);
  }, [propertyType]);
  var propertyRef = useRef(property);
  useEffect(function () {
    if (property && !propertyRef.current) {
      propertyRef.current = property;
      setEditMode(true);
    }
  }, [property]);
  useEffect(function () {
    if (editMode) {
      var index = operators.findIndex(function (_ref2) {
        var value = _ref2.value;
        return value === operator;
      });
      setIndex(index);
    }

    return function () {
      return setIndex(null);
    };
  }, [editMode]);

  var keyboardHandler = function keyboardHandler(_e, keyCode) {
    switch (keyCode) {
      case KEYBOARD_KEYS.ENTER:
        var value = operators[selectionIndex].value;
        onChange(value);
        setEditMode(false);
        break;

      case KEYBOARD_KEYS.UP:
        if (selectionIndex > 0) {
          setIndex(selectionIndex - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (selectionIndex === null) {
          setIndex(0);
        } else if (selectionIndex < operators.length - 1) {
          setIndex(selectionIndex + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        setEditMode(false);
        break;
    }
  };

  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ENTER, KEYBOARD_KEYS.ESCAPE, KEYBOARD_KEYS.UP, KEYBOARD_KEYS.DOWN],
    addEventListenerCondition: editMode,
    eventListenerDependencies: [editMode]
  });
  return React.createElement(Container, null, React.createElement(DropableContainer, {
    isActive: editMode,
    variant: "secondary",
    onClick: function onClick() {
      return !editMode && propertyType && setEditMode(true);
    },
    onDefocus: function onDefocus() {
      return setEditMode(false);
    },
    placeholder: t('query_creator_filter_operator.placeholder'),
    value: operator
  }, getLabel(propertyType, operator)), React.createElement(Dropdown, {
    isOpen: editMode,
    fullWidth: false
  }, React.createElement(OperatorsList, {
    "data-testid": "operators-list"
  }, React.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 240
  }, function (activeItemRef) {
    return React.createElement(DropdownList, {
      ref: activeItemRef,
      items: operators,
      setActiveItem: function setActiveItem(_ref3) {
        var value = _ref3.value;
        return operators[selectionIndex] && value === operators[selectionIndex].value;
      },
      onClick: function onClick(_e, _ref4) {
        var value = _ref4.value;
        setEditMode(false);
        onChange(value);
      }
    });
  }))));
};

export default FilterOperator;